import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/Login/Login.vue'
import SignupMain from '@/views/SignupMain/SignupMain.vue'
import SignupMini from '@/views/SignupMini/SignupMini.vue'
import { nextForSignupMain } from '@/router/signup-guards'
import Auth from '@/views/Auth/Auth.vue'
import Home from '@/views/Home/Home.vue'
import Workspace from '@/views/Workspace/Workspace.vue'
import Keywords from '@/views/Keywords/Keywords.vue'
import CreateContentplan from '@/views/CreateContentplan/CreateContentplan.vue'
import Article from '@/views/Article/Article.vue'
import ArticleShared from '@/views/ArticleShared/ArticleShared.vue'
import Plan from '@/views/Plan/Plan.vue'
import HubDetail from '@/views/HubDetail/HubDetail.vue'
import NewArticle from '@/views/NewArticle/NewArticle.vue'
import Pages from '@/views/PagesEcom/PagesEcom.vue'
import PageSimilarity from '@/views/PageSimilarity/PageSimilarity.vue'
import Report from '@/views/Report/Report.vue'
import EcommerceReport from '@/views/EcommerceReport/EcommerceReport.vue'
import Competitors from '@/views/Competitors/Competitors.vue'
import Sprints from '@/views/Sprints/Sprints.vue'
import Mindmap from '@/views/Mindmap/Mindmap.vue'
import MindmapSales from '@/views/MindmapSales/MindmapSales.vue'
import RoiCalculator from '@/views/RoiCalculator/RoiCalculator.vue'
import ContentplanSettings from '@/views/ContentplanSettings/ContentplanSettings.vue'
import WordpressIntegration from '@/views/Integrations/WordpressIntegration/WordpressIntegration.vue'
import GoogleAnalyticsIntegration from '@/views/Integrations/GoogleAnalyticsIntegration/GoogleAnalyticsIntegration.vue'
import BigQueryIntegration from '@/views/Integrations/BigQueryIntegration/BigQueryIntegration.vue'
import SearchConsoleIntegration from '@/views/Integrations/SearchConsoleIntegration/SearchConsoleIntegration.vue'
import NotionIntegration from '@/views/Integrations/NotionIntegration/NotionIntegration.vue'
import WebflowIntegration from '@/views/Integrations/WebflowIntegration/WebflowIntegration.vue'
import ShopifyIntegration from '@/views/Integrations/ShopifyIntegration/ShopifyIntegration.vue'
import ShopifyAuthCallback from '@/views/Integrations/ShopifyIntegration/ShopifyAuthCallback.vue'
import ShopifyInstall from '@/views/Integrations/ShopifyIntegration/ShopifyInstall.vue'
import CustomCmsIntegration from '@/views/Integrations/CustomCmsIntegration/CustomCmsIntegration.vue'
import GeckoCmsIntegration from '@/views/Integrations/GeckoCmsIntegration/GeckoCmsIntegration.vue'
import MagentoIntegration from '@/views/Integrations/MagentoIntegration/MagentoIntegration.vue'
import Director from '@/views/Director/Director.vue'
import InternalLinks from '@/views/InternalLinks/InternalLinks.vue'
import ClustererFree from '@/views/ClustererFree/ClustererFree.vue'
import ClustererPaid from '@/views/ClustererPaid/ClustererPaid.vue'
import EcommerceFree from '@/views/EcommerceFree/EcommerceFree.vue'
import ListicleFinder from '@/views/ListicleFinder/ListicleFinder.vue'
import WriterFree from '@/views/WriterFree/WriterFree.vue'
import WriterPaid from '@/views/WriterPaid/WriterPaid.vue'
import ResearchPaid from '@/views/ResearchPaid/ResearchPaid.vue'
import CategoryContent from '@/views/CategoryContent/CategoryContent.vue'
import CategoryContentSettings from '@/views/CategoryContent/CategoryContentSettings.vue'
// import SaaSSemanticClusterer from '@/views/SaaSSemanticClusterer/SaaSSemanticClusterer.vue'
import WorkspaceSettings from '@/views/WorkspaceSettings/WorkspaceSettings.vue'
import StripeLander from '@/views/StripeLander/StripeLander.vue'
import ContentEditor from '@/views/ContentEditor/ContentEditor.vue'
import TranslatedArticles from '@/views/TranslatedArticles/TranslatedArticles.vue'
import NewHub from '@/views/NewHub/NewHub.vue'
import ChatPlayground from '@/views/ChatPlayground/ChatPlayground.vue'
import AdminContentplansOverview from '@/views/AdminContentplansOverview/AdminContentplansOverview.vue'
import AdminImpactReport from '@/views/AdminImpactReport/AdminImpactReport.vue'
import AdminInvestorReport from '@/views/AdminInvestorReport/AdminInvestorReport.vue'
import AdminLinkSources from '@/views/AdminLinkSources/AdminLinkSources.vue'
import AdminCopilot from '@/views/AdminCopilot/AdminCopilot.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/login',
    redirect: '/'
  },
  {
    path: '/main',
    name: 'SignupMain',
    component: SignupMain
  },
  {
    path: '/mini',
    name: 'SignupMini',
    component: SignupMini
  },
  {
    path: '/managed',
    redirect: to => ({ path: '/main', query: to.query })
  },
  {
    path: '/auth/:action',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/workspace',
    name: 'WorkspaceList',
    component: Workspace
  },
  {
    path: '/workspace/:workspaceId',
    name: 'Workspace',
    component: Workspace
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/keywords',
    name: 'Keywords',
    component: Keywords
  },
  {
    path: '/workspace/:workspaceId/contentplan/add',
    name: 'CreateContentplan',
    component: CreateContentplan
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/onboarding/gsc',
    name: 'CreateContentplanStep3',
    component: CreateContentplan
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/onboarding/shopify',
    name: 'CreateContentplanShopify',
    component: CreateContentplan
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/onboarding/wordpress',
    name: 'CreateContentplanStep4',
    component: CreateContentplan
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/article/:articleId',
    name: 'Article',
    component: Article
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/article/:articleId/:sharingKey',
    name: 'ArticleShared',
    component: ArticleShared
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/plan/:filter?',
    name: 'Plan',
    component: Plan
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/hub/:topicId?',
    name: 'HubDetail',
    component: HubDetail
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/new-article',
    name: 'NewArticle',
    component: NewArticle
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/pages',
    name: 'Pages',
    component: Pages
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/page-similarity',
    name: 'PageSimilarity',
    component: PageSimilarity
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/category-content',
    name: 'CategoryContent',
    component: CategoryContent
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/category-content/settings',
    name: 'CategoryContentSettings',
    component: CategoryContentSettings
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/report',
    name: 'Report',
    component: Report
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/report/:sharingKey',
    name: 'ReportShared',
    component: Report
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/ecommerce-report',
    name: 'EcommerceReport',
    component: EcommerceReport
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/competitors',
    name: 'Competitors',
    component: Competitors
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/sprints',
    name: 'Sprints',
    component: Sprints
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/map',
    name: 'Mindmap',
    component: Mindmap
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/map/:sharingKey',
    name: 'MindmapSales',
    component: MindmapSales
  },
  {
    path: '/roi-calculator',
    name: 'RoiCalculator',
    component: RoiCalculator
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/settings',
    name: 'ContentplanSettings',
    component: ContentplanSettings
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/wordpress-integration',
    name: 'WordpressIntegration',
    component: WordpressIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/site-builder-integration',
    name: 'WebflowIntegration',
    component: WebflowIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/shopify-integration',
    name: 'ShopifyIntegration',
    component: ShopifyIntegration
  },
  {
    path: '/notion-integration',
    name: 'NotionIntegration',
    component: NotionIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/ga-integration',
    name: 'GoogleAnalyticsIntegration',
    component: GoogleAnalyticsIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/bigquery-integration',
    name: 'BigQueryIntegration',
    component: BigQueryIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/gsc-integration',
    name: 'SearchConsoleIntegration',
    component: SearchConsoleIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/director',
    name: 'Director',
    component: Director
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/director/:sharingKey',
    name: 'DirectorShared',
    component: Director
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/internal-links',
    name: 'InternalLinks',
    component: InternalLinks
  },
  {
    path: '/clusterer',
    name: 'ClustererFree',
    component: ClustererFree
  },
  {
    path: '/ecommerce-analyzer',
    name: 'EcommerceFree',
    component: EcommerceFree
  },
  {
    path: '/workspace/:workspaceId/ultimate-clusterer',
    name: 'ClustererPaid',
    component: ClustererPaid
  },
  {
    path: '/listicle-finder',
    name: 'ListicleFinder',
    component: ListicleFinder
  },
  {
    path: '/ai-writer-free',
    name: 'WriterFree',
    component: WriterFree
  },
  {
    path: '/workspace/:workspaceId/ai-writer',
    name: 'WriterPaid',
    component: WriterPaid
  },
  {
    path: '/workspace/:workspaceId/keyword-research',
    name: 'ResearchPaid',
    component: ResearchPaid
  },
  // {
  //   path: '/workspace/:workspaceId/semantic-clusterer',
  //   name: 'SaaSSemanticClusterer',
  //   component: SaaSSemanticClusterer
  // },
  {
    path: '/workspace/:workspaceId/settings',
    name: 'WorkspaceSettings',
    component: WorkspaceSettings
  },
  {
    path: '/workspace/:workspaceId/stripe-success',
    name: 'StripeLander',
    component: StripeLander
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/content-editor',
    name: 'ContentEditor',
    component: ContentEditor
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/chat',
    name: 'ChatPlayground',
    component: ChatPlayground
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/translated-articles',
    name: 'TranslatedArticles',
    component: TranslatedArticles
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/new-hub',
    name: 'NewHub',
    component: NewHub
  },
  {
    path: '/integrations/shopify/connect',
    name: 'ShopifyConnect',
    component: ShopifyInstall
  },
  {
    path: '/shopify-install',
    name: 'ShopifyInstall',
    component: ShopifyInstall
  },
  {
    path: '/shopify-auth-callback',
    name: 'ShopifyAuthCallback',
    component: ShopifyAuthCallback
  },
  {
    path: '/admin',
    name: 'AdminContentplansOverview',
    component: AdminContentplansOverview
  },
  {
    path: '/admin/impact-report',
    name: 'AdminImpactReport',
    component: AdminImpactReport
  },
  {
    path: '/admin/investor-report',
    name: 'AdminInvestorReport',
    component: AdminInvestorReport
  },
  {
    path: '/admin/link-sources',
    name: 'AdminLinkSources',
    component: AdminLinkSources
  },
  {
    path: '/admin/copilot',
    name: 'AdminCopilot',
    component: AdminCopilot
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/custom-cms-integration',
    name: 'CustomCmsIntegration',
    component: CustomCmsIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/gecko-cms-integration',
    name: 'GeckoCmsIntegration',
    component: GeckoCmsIntegration
  },
  {
    path: '/workspace/:workspaceId/contentplan/:contentplanId/magento-integration',
    name: 'MagentoIntegration',
    component: MagentoIntegration
  }
]

if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/dev/agent-chat',
    name: 'AgentChatDemo',
    component: require('@/views/AgentChatDemo/AgentChatDemo.vue').default
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Route guard for CreateContentplan steps
router.beforeEach((to, from, next) => {
  const signupRedirect = nextForSignupMain(to)
  if (signupRedirect) {
    next(signupRedirect)
    return
  }

  // Only apply guard to CreateContentplan routes
  if (to.name && to.name.startsWith('CreateContentplan')) {
    const stepRoutes = {
      CreateContentplan: 1,
      CreateContentplanStep3: 2,
      CreateContentplanShopify: 2,
      CreateContentplanStep4: 3
    }

    const targetStep = stepRoutes[to.name]
    const contentplanId = to.params.contentplanId

    // For step 1, always allow access
    if (targetStep === 1) {
      next()
      return
    }

    // For other steps, only require contentplanId (no other restrictions)
    if (targetStep > 1 && !contentplanId) {
      next({
        name: 'CreateContentplan',
        params: { workspaceId: to.params.workspaceId }
      })
      return
    }
  }

  next()
})

export default router
